let getKeyWord = function(str) {
  let lastIndex = str.lastIndexOf('_');

  if(lastIndex > -1){
    return str.substring(0,lastIndex);
  }else{
    return '';
  }
}

export function getCurKeyWord(str) {
  return getKeyWord(str)
}



// WEBPACK FOOTER //
// ./src/utils/util.js